import { useFormContext, useWatch } from 'react-hook-form';
import { AppointmentsReservePayload } from 'pages/AppointmentsReserve/constants';
import { type AppointmentsReserveFormData } from 'pages/AppointmentsReserve/types';
import { hasFixedPsychologist } from 'pages/AppointmentsReserve/utils';
import { useFetchFreeHours, type UseFetchFreeHoursResult } from './useFetchFreeHours';
import { useFetchPsychologistAvailability } from './useFetchPsychologistAvailability';

/**
 * Availability of the current flow: the selected professional's agenda when the professional
 * is already fixed, or the free hours of the center for automatic assignment otherwise.
 */
export const useSessionAvailability = (): UseFetchFreeHoursResult => {
  const { control } = useFormContext<AppointmentsReserveFormData>();
  const flow = useWatch({ control, name: AppointmentsReservePayload.flow });
  const isProfessionalFixed = hasFixedPsychologist(flow);
  const freeHoursAvailability = useFetchFreeHours(!isProfessionalFixed);
  const psychologistAvailability = useFetchPsychologistAvailability(isProfessionalFixed);

  return isProfessionalFixed ? psychologistAvailability : freeHoursAvailability;
};
